import { OverallValidationResult, validator } from '../../../tradebuilder-v2/util'
import { EditPortfoliosState } from '../edit-portfolio-slice'
import { editPortfolioRules } from './edit-portfolio'

const editPortfolioValidator = validator(editPortfolioRules)

export function validate(portfolioState: EditPortfoliosState): OverallValidationResult {
  return editPortfolioValidator(portfolioState)
}
